<template>
    <spinner v-if="isLoading"></spinner>
    <transition name="fade">
        <div>
            <BreadCrumbs
                :breadCrumbs="breadCrumbs"
                :title="this.title"
                :back_title="this.back_title"
                :link="this.link" />
            
            <div class="page">
                
                <h5 class="my-3 hstack">
                    <Buying :count="7"/>
                    Осмотр салона
                </h5>

                <hr>
                <div class="legend">
                    <div class="legend_row hstack fs-7">
                        <span class="material-symbols-rounded me-1" style="color: #4c586d;">help</span> &ndash; не проверено
                    </div>
                    <div class="legend_row hstack fs-7">
                        <span class="material-symbols-rounded me-1" style="color: #00c43c;">check_circle</span> &ndash; проверено, нет дефектов
                    </div>
                    <div class="legend_row hstack fs-7">
                        <span class="material-symbols-rounded me-1" style="color: #cc0000;">error</span> &ndash; проверено, есть дефекты
                    </div>
                </div>
                <hr>

                <!-- Check List -->
                <div class="vstack justify-content-center mt-0">
                    <div v-for="item in array" :key="item.id">
                        <button class="btn cl_item cl_status pad mb-2 w-100 text-center hstack"
                            @click="addChecking(item.item_id)"
                            :class="goStatusClass(item.status)"
                        >
                            <span v-if="item.status == 'accept'" class="material-symbols-rounded me-2 opacity-50 cl_status_icon">check_circle</span>
                            <span v-else-if="item.status == 'defect'" class="material-symbols-rounded me-2 opacity-50 cl_status_icon">error</span>
                            <span v-else class="material-symbols-rounded me-2 opacity-50 cl_status_icon">help</span>
                            {{ item.items.name }}
                        </button>
                    </div>
                </div>

                <button class="btn btn-green w-100 mt-3 mb-5" @click="saveStep" >Сохранить</button>

            </div>
        </div>
    </transition>
        
    <transition-group name="list">
        <details-body
            v-if="isVisible"
            :wear="wear"
            :itemId="itemId"
            :damage="damage"
            :image="images"
            :name="name"
            :type_inspection="'interior'"
            :inspectionId="inspectionId"
            :comment="comments"
            @close-form="hideFormBody"
            @add-defect="addDefect($event)"
        />
    </transition-group>
</template>

<script>
import Buying from "./Buying";
import DetailsBody from "./detailsBody";
import axios from "axios";
import spinner from "../../components/Spinner";
import BreadCrumbs from "../../Page/BreadCrumbs";

export default {
    name: "Step_7",
    components: {
        DetailsBody,
        Buying,
        spinner,
        BreadCrumbs
    },
    data: () => ({
        step: 'undersoot',
        back_step: 'outside',
        isVisible: false,
        item_47: null,
        item_48: null,
        item_49: null,
        item_50: null,
        item_51: null,
        item_52: null,
        item_53: null,
        item_54: null,
        item_55: null,
        item_56: null,
        item_57: null,
        array: [],
        parts: [],
        isLoading: false,
        images: [],
        comments: '',
        name: '',
        car: [],
        wear: [],
        damage: [],
        inspectionId: null,
        itemId: null,
        breadCrumbs: true,
        title: "Осмотр салона",
        back_title: "Этапы приёма",
        link: "",
    }),
    created() {
        this.getData();
        this.getBackLink();
    },
    methods: {
        getBackLink() {
            this.link = this.link = `tradeinlist/${this.$route.params.id}`
        },
        saveStep(){
            this.isLoading = true;
            const config = {'headers': { 'Authorization': 'Bearer ' + this.$cookie.getCookie('token') }};
            axios.post(`/api/admin/tradein/inspection/save/step`, {
                id: this.$route.params.id,
                step_number: 7,
                type: 'interior',
            }, config)

                .then(response =>{
                    if(response.status == 200){
                        /* this.$flashMessage.show({
                             type: 'success',
                             text: 'Пункт меню успешно удален!',
                         });*/
                        this.$router.push(`/buying/undersoot/${this.$route.params.id}`);
                    }
                })
                .catch(error =>{
                    this.isLoading = false;
                    console.log(error);
                });
        },
        addDefect(event){
            this.isLoading = true;
            const config = {'headers': { 'Authorization': 'Bearer ' + this.$cookie.getCookie('token') }};
            axios.post(`/api/admin/tradein/inspection/add/checking`, {
                part_id: event.part_id,
                item_id: event.item_id,
                inspection_id: event.inspection_id,
                type_inspection: event.type_inspection,
                type: event.type,
                comment: event.comment,
                slug: 'defect',
            }, config)
                .then(response =>{
                    if(response.status == 200){
                        this.getChecking(event.item_id);
                    }
                })
                .catch(error =>{
                    this.isLoading = false;
                    console.log(error);
                });
        },
        async getData(){
            try {
                this.isLoading = true;
                const config = {'headers': { 'Authorization': 'Bearer ' + this.$cookie.getCookie('token') }};
                const response = await axios.get(`/api/admin/tradein/inspection/${this.$route.params.id}/interior`, config);
                this.array = response.data.data.data;
                this.item_47 = this.array[47]['status'];
                this.item_48 = this.array[48]['status'];
                this.item_49 = this.array[49]['status'];
                this.item_50 = this.array[50]['status'];
                this.item_51 = this.array[51]['status'];
                this.item_52 = this.array[52]['status'];
                this.item_53 = this.array[53]['status'];
                this.item_54 = this.array[54]['status'];
                this.item_55 = this.array[55]['status'];
                this.item_56 = this.array[56]['status'];
                this.item_57 = this.array[57]['status'];
                this.car = response.data.data.car;
                this.isLoading = false;
            } catch (e) {
                console.log(e);
            } finally {
            }
        },
        async getChecking(id){
            try {
                this.isLoading = true;
                const config = {'headers': { 'Authorization': 'Bearer ' + this.$cookie.getCookie('token') }};
                const response = await axios.get(`/api/admin/tradein/inspection/checking/${this.$route.params.id}/${id}/interior/null`, config);
                this.parts = response.data.data.data;
                this.wear = this.parts.data.wear;
                this.damage = this.parts.data.damage;
                this.inspectionId = this.parts.id;
                this.itemId = this.parts.item_id;
                this.name = this.parts.items.name;
                this.images = response.data.data.images;
                this.comments = response.data.data.comment;

            } catch (e) {
                console.log(e);
            } finally {
                this.isLoading = false;
            }
        },
        addChecking(id){
            this.getChecking(id);
            this.isVisible = true;
        },
        hideFormBody(){
            this.getData();
            this.isVisible = false;
        },
        goClass(status){
            if(status === 'not_verified'){
                return '#808080';
            }else if(status === 'accept'){
                return '#338833';
            }else if(status === 'defect'){
                return '#CC0000';
            }
        },
        goStatusClass(status) {
            return `type_${status}`;
        },
    }
}
</script>

<style scoped>

</style>
